var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewborn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 46,
    fill: "#FBE1D1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#A65F49",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45 73.5c0-10.2 8.5-18.5 19-18.5s19 8.3 19 18.5V78c0 11-8.5 20-19 20s-19-9-19-20v-4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 55.5V51c0-7 5.4-12.5 12-12.5S76 44 76 51v4.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5 48.5c2.5-4.2 7.5-5.3 11.5-2.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2 51.5c1.3 1 2.7 1.5 4.2 1.5M67.2 53c1.5 0 2.9-.5 4.2-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5 57.5c1 1 2.2 1.5 3.5 1.5s2.5-.5 3.5-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.5 68 32.8 20M80.5 68 47.7 88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53 91.5h22"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewborn);
export default __webpack_public_path__ + "static/media/newborn.5e5fcf9fe7c2809cf0654954ec90f41f.svg";
export { ForwardRef as ReactComponent };